import React from 'react';
import { TextField, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  disabledTextField: {
    '& .MuiFormLabel-root.Mui-disabled': {
      color: (props) => `${props.disabledTextColor} !important` || 'inherit',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: (props) => `${props.disabledTextColor} !important` || 'inherit',
      '-webkit-text-fill-color': (props) => `${props.disabledTextColor} !important` || 'inherit',
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: (props) => `${props.disabledBorderColor} !important` || 'inherit',
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      borderColor: (props) => `${props.disabledBorderColor} !important` || 'inherit',
    },
    '& .MuiInput-root.Mui-disabled:before': {
      borderBottomColor: (props) => `${props.disabledBorderColor} !important` || 'inherit',
    }
  }
}));

const CommonTextField = ({
  name,
  label,
  value,
  error,
  helperText,
  touched,
  handleBlur,
  handleChange,
  crudAction,
  placeholder,
  required = false,
  type = "text",
  multiline = false,
  rows,
  className = "inputRounded",
  variant = "outlined",
  fullWidth = true,
  disabled,
  InputLabelProps,
  disabledTextColor,
  disabledBorderColor,
  ...otherProps
}) => {
  const defaultInputLabelProps = {
    shrink: true,
    style: {
      backgroundColor: 'white',
      paddingRight: '8px',
      fontSize: 14,
      ...InputLabelProps?.style
    },
    ...InputLabelProps
  };

  const isDisabled = disabled !== undefined 
    ? disabled 
    : (crudAction?.view || crudAction?.delete);

  const placeholderText = placeholder !== undefined 
    ? placeholder 
    : ((crudAction?.view || crudAction?.delete) ? "" : "Enter");

  const classes = useStyles({ 
    disabledTextColor: isDisabled ? disabledTextColor : null, 
    disabledBorderColor: isDisabled ? disabledBorderColor : null 
  });

  // Combine className with disabled styles
  const finalClassName = isDisabled && (disabledTextColor || disabledBorderColor) 
    ? `${className} ${classes.disabledTextField}` 
    : className;

  // Alternative approach: Direct style injection for disabled state
  const getInputProps = () => {
    if (isDisabled && disabledTextColor) {
      return {
        style: {
          color: disabledTextColor,
          WebkitTextFillColor: disabledTextColor,
        }
      };
    }
    return {};
  };

  const getOutlineInputProps = () => {
    if (isDisabled && disabledBorderColor) {
      return {
        style: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: disabledBorderColor + ' !important',
          }
        }
      };
    }
    return {};
  };

  return (
    <TextField
      error={touched?.[name] && error}
      helperText={touched?.[name] && helperText}
      name={name}
      className={finalClassName}
      label={label}
      placeholder={placeholderText}
      fullWidth={fullWidth}
      value={value}
      onBlur={handleBlur}
      onChange={handleChange}
      disabled={isDisabled}
      required={required}
      variant={variant}
      type={type}
      multiline={multiline}
      rows={rows}
      InputLabelProps={defaultInputLabelProps}
      inputProps={getInputProps()}
      InputProps={{
        ...getOutlineInputProps(),
        ...otherProps.InputProps
      }}
      {...otherProps}
    />
  );
};

export default CommonTextField; 